/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Aiquestion1Inputs */

const zh_landing_admin_aiquestion1 = /** @type {(inputs: Landing_Admin_Aiquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以用通俗的方式解释一下光合作用吗？`)
};

const en_landing_admin_aiquestion1 = /** @type {(inputs: Landing_Admin_Aiquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can you explain photosynthesis in simple terms?`)
};

const es_landing_admin_aiquestion1 = /** @type {(inputs: Landing_Admin_Aiquestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedes explicar la fotosíntesis de forma sencilla?`)
};

/**
* | output |
* | --- |
* | "Can you explain photosynthesis in simple terms?" |
*
* @param {Landing_Admin_Aiquestion1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_aiquestion1 = /** @type {((inputs?: Landing_Admin_Aiquestion1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Aiquestion1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_aiquestion1(inputs)
	if (locale === "en") return en_landing_admin_aiquestion1(inputs)
	return es_landing_admin_aiquestion1(inputs)
});
export { landing_admin_aiquestion1 as "landing_admin_aiQuestion" }